// extracted by mini-css-extract-plugin
export default {"overlay":"ImageZoomer_overlay__ohX9m","img":"ImageZoomer_img__OakuM"};